import { format } from "date-fns";

/**
 * 請求月から使用月のラベルを取得する。当月の場合は「当月」を返す。
 * @param billingDate - 月次予算状況の請求日
 * @returns 使用年月のテキスト（例: "2026/07"）。当月の場合は "当月"
 */
export const getUsageYearMonthText = (billingDate: Date): string => {
  const now = new Date();
  const isCurrentMonth =
    billingDate.getFullYear() === now.getFullYear() &&
    billingDate.getMonth() === now.getMonth();
  return isCurrentMonth ? "当月" : format(billingDate, "yyyy/MM");
};
